import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import "./StoryVideoBlock.scss";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#___gatsby');

const StoryVideoBlock = ({ value }) => {
  console.log(value, value?.VideoFile);
  const [modalOpen, setModalOpen] = useState(false);
  const videoRef = useRef(null);
  const [play, setPlay] = useState(false);

  const handlePlayVideo = () => {
    videoRef?.current?.play();
    setPlay(true);
  }

  const handleOpen = () => {
    setPlay(false);
    setModalOpen(true);
  }
  const handleClose = () => {
    setPlay(false);
    setModalOpen(false);
  }

  return (
    <div className="block-video-story">
      <div className="block-video-story__content">
        <div className="block-content">
          <h3>{value?.title}</h3>
          <p>{value?.description}</p>
        </div>
        <div className="block-video">
          <button onClick={handleOpen}>
            <img
              src={value?.thumbnail?.asset?.url}
              width={value?.thumbnail?.asset?.width}
              height={value?.thumbnail?.asset?.height}
              alt={value?.thumbnail?.altText}
              loading='lazy'
            />
          </button>
        </div>
      </div>
      <Modal
        isOpen={modalOpen}
        onRequestClose={handleClose}
        style={customStyles}
        className={'story-videoModal'}
        contentLabel="story-video-block-modal"
        bodyOpenClassName={'no-scroll'}
      >
        <button onClick={handleClose} className='modal-closeBtn'>
          <svg xmlns="http://www.w3.org/2000/svg" width="22.629" height="22.627" viewBox="0 0 22.629 22.627">
            <g id="Hamburger_lines" data-name="Hamburger lines" transform="translate(-3.628 -1.49)">
              <rect id="Rectangle_98" data-name="Rectangle 98" width="30" height="2" rx="1" transform="translate(5.042 1.49) rotate(45)" fill="#d93f04" />
              <rect id="Rectangle_49" data-name="Rectangle 49" width="30" height="2" rx="1" transform="translate(3.63 22.703) rotate(-45)" fill="#d93f04" />
            </g>
          </svg>

        </button>
        <div className='modal-content'>
          <button
            onClick={handlePlayVideo}
            className=''
            style={{ display: play ? 'none' : 'initial' }}
          >
            <img
              src={value?.thumbnail?.asset?.url}
              width={value?.thumbnail?.asset?.width}
              height={value?.thumbnail?.asset?.height}
              alt={value?.thumbnail?.altText}
              loading='lazy'
            />
          </button>
          <video
            ref={videoRef}
            src={value?.videoFile?.asset?.url}
            playsInline
            controls
            style={{ display: !play ? 'none' : 'initial', }}
          >
            <track default kind="captions" srcLang="en" src="#" />
          </video>
        </div>
      </Modal>
    </div>
  )
}

export default StoryVideoBlock